/**
 * Enum representing referral reasons for a quote.
 */
 export enum ReferralReason {
    ReferralNotNeeded = 0,
    SubOccupationReferral = 1,
    EntityReferral = 2,
    SubOccupationAndEntityReferral = 3
}